module.exports = __webpack_public_path__ + "img/sage.3cfcf4a0.png";